import { mapActions, mapState } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';

export default {
  mixins: [
    formMixin,
  ],
  data() {
    return {
      statement: '',
      mandatoryStatement: '',
      fields: {
        taxId: '',
        zipCode: '',
        stateCode: '',
        city: '',
        address: '',
        name: '',
      },
    };
  },
  validations: {
    fields: {
      taxId: validators.taxId,
      zipCode: validators.required,
      stateCode: validators.required,
      city: validators.required,
      address: validators.required,
      name: validators.required,
    },
  },
  computed: {
    ...mapState('app', ['systemEmails']),
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['getTaxInfo', 'postTaxInfo']),
    ...mapActions('app', ['setMandatoryTaxNotification']),
    ...mapActions('notifications', ['setSuccessSideNotification']),
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        const payload = {
          taxId: this.fields.taxId,
          zipCode: this.fields.zipCode,
          stateCode: this.fields.stateCode,
          city: this.fields.city,
          address1: this.fields.address,
          name: this.fields.name,
        };
        this.postTaxInfo(payload)
          .then((data) => {
            this.setCurrentPopup();
            this.setSuccessSideNotification(data.message);
          })
          .catch(error => this.formHandleErrors(error));
      }
    },
  },
  created() {
    const reasonCode = this.$route.query.reason || '';
    this.getTaxInfo({ reasonCode })
      .then((data) => {
        this.setMandatoryTaxNotification(data.isMandatory);
        this.fields.address = data.address1;
        this.fields.city = data.city;
        this.fields.name = data.name;
        this.fields.zipCode = data.zipCode;
        this.fields.stateCode = data.stateCode;
        this.mandatoryStatement = data.mandatoryStatement;
        this.statement = data.statement;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/tax-info-notification/tax-info-notification.js